// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header___3j9Ys"};